$(document).ready(function(){

	// -- polyfill --
	$('details').details();
	$('html').addClass($.fn.details.support ? 'details' : 'no-details');

	// -- button close --
	$('details .btn--close').on('click', function(){
		var detail = $(this).parents('details');
		detail.removeClass('open').prop('open', false).triggerHandler('close.details');
		detail.find('summary').attr('aria-expanded', false);
		detail.find('.content').css({'opacity':0});
	});

});